import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  GoogleAuthProvider,
  reload,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithCustomToken,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updateProfile
} from "firebase/auth";

const app = initializeApp({
  apiKey: "AIzaSyB8MaCNaNayztB8SXkhRxSvEnly5ykYdFg",
  authDomain: "versecomm-195e9.firebaseapp.com",
  projectId: "versecomm-195e9",
  storageBucket: "versecomm-195e9.firebasestorage.app",
  messagingSenderId: "768070077286"
});

export const firebaseAuth = getAuth(app);

export async function registerEmail(email: string, password: string, displayName: string) {
  const result = await createUserWithEmailAndPassword(firebaseAuth, email, password);
  await updateProfile(result.user, { displayName });
  await sendEmailVerification(result.user);
  await signOut(firebaseAuth);
}

export async function loginEmail(email: string, password: string) {
  const result = await signInWithEmailAndPassword(firebaseAuth, email, password);
  await reload(result.user);
  if (!result.user.emailVerified) {
    await sendEmailVerification(result.user).catch(() => undefined);
    await signOut(firebaseAuth);
    throw new Error("Please verify your email first. We sent a new verification email.");
  }
  return result.user.getIdToken(false);
}

export async function loginGoogle() {
  const desktopBridge = (window as Window & {
    verseDesktop?: {
      isDesktop?: boolean;
      loginWithGoogle?: () => Promise<string>;
    };
  }).verseDesktop;
  if (desktopBridge?.isDesktop && desktopBridge.loginWithGoogle) {
    const customToken = await desktopBridge.loginWithGoogle();
    const result = await signInWithCustomToken(firebaseAuth, customToken);
    return result.user.getIdToken(false);
  }
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  const result = await signInWithPopup(firebaseAuth, provider);
  return result.user.getIdToken(false);
}

export async function resetPassword(email: string) {
  await sendPasswordResetEmail(firebaseAuth, email);
}

export function logoutFirebase() {
  return signOut(firebaseAuth);
}
